module.exports = __webpack_public_path__ + "static/media/thank-you.53f5d633.png";